import React from 'react'

import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { formatDollar, formatEnglishShortDate, sumAmount } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'

const PaymentDetails = ({ hardwareData, softwareData, servicesData }) => {
  const serviceOrder = useServiceOrder()

  const allData = [...hardwareData, ...softwareData, ...servicesData]

  return (
    <>
      <Text bold size="h5">
        Payment Details
      </Text>
      <Separator weight={5} />
      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="7">
            <Text bold>{formatEnglishShortDate(serviceOrder?.endDate)}</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
          <TableCol useFontBaseColor>
            <Text bold>Invoice Plan</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Item</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Description</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Qty</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Subtotal</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Tax</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Total</Text>
          </TableCol>
        </TableRow>
        {allData.map((item, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor>
              <Text>{item.invoicePlan}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.item}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.description}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.quantity}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.subtotal)}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.tax)}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatDollar(item.total)}</Text>
            </TableCol>
          </TableRow>
        ))}
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="4">
            <Text bold>Total</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{formatDollar(sumAmount(allData, 'subtotal'))}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{formatDollar(sumAmount(allData, 'tax'))}</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>{formatDollar(sumAmount(allData, 'total'))}</Text>
          </TableCol>
        </TableRow>
      </Table>
    </>
  )
}

export default PaymentDetails
